export const navigation = [
  {
    label: "Operação",
    items: [
      { path: "/gesture-map", label: "Mapa de gestão", icon: "view-dashboard-outline" },
      { path: "/devices-map", label: "Monitoramento", icon: "map-marker-radius" },
      { path: "/gps-map", label: "Mapa GPS", icon: "crosshairs-gps" },
    ],
  },
  {
    label: "Cadastros",
    icon: "folder-outline",
    items: [
      { path: "/forms/customers", label: "Clientes" },
      { path: "/forms/users", label: "Usuários" },
      { path: "/forms/drivers", label: "Motoristas" },
      { path: "/forms/trailers", label: "Carretas" },
      { path: "/forms/shippers", label: "Embarcadores" },
      { path: "/forms/productProfiles", label: "Perfis de Produto" },
      { path: "/forms/simCards", label: "Chips / SIM cards" },
      { path: "/forms/units-thermoking", label: "Unidades Refrigeradas" },
    ],
  },
  {
    label: "Gestão",
    icon: "briefcase-outline",
    items: [
      { path: "/forms/fuelSupplies", label: "Abastecimentos" },
      { path: "/forms/suppliers", label: "Fornecedores" },
      { path: "/forms/products", label: "Produtos e Serviços" },
      { path: "/forms/travels", label: "Viagens" },
      { path: "/forms/expenses", label: "Despesas" },
      { path: "/forms/commands", label: "Comandos" },
    ],
  },
  {
    label: "Manutenção",
    icon: "wrench-outline",
    items: [
      { path: "/forms/maintenancePlan", label: "Planos de Manutenção" },
      { path: "/forms/maintenanceSchedule", label: "Agendas de Manutenção" },
    ],
  },
  {
    label: "Análises",
    icon: "chart-line",
    items: [
      { path: "/positions-history", label: "Histórico de Posições" },
      { path: "/events-history", label: "Histórico de Eventos" },
      { path: "/charts/temperatures", label: "Gráfico de Temperaturas" },
      { path: "/reports/temperatures", label: "Relatório de Temperaturas" },
      { path: "/reports/travels", label: "Relatório de Viagens" },
    ],
  },
];
export const pageInfo = (pathname) => {
  for (const group of navigation) {
    const item = group.items.find((item) => item.path === pathname);
    if (item) return { ...item, section: group.label };
  }
  return { label: "Workspace", section: "Thermoking" };
};
